import { Loader, Tooltip } from '@wix/design-system';
import type { RicosEditorAPI } from '@wix/ricos';
import type { Environment } from '@wix/ricos/internal';
import type { EditorPluginName } from '@wix/ricos/schema-next';
import React from 'react';

import { Card } from './card';
import { ErrorBoundary } from './error-boundary';

const Editor = React.lazy(() => import('./editor'));

export const EditorCard: React.FC<{
  headerRightButtons?: React.ReactNode;
  headerCenter?: React.ReactNode;
  footer?: React.ReactNode;
  content: object;
  editorRemountKey: number;
  onChange: (content: object) => void;
  plugins: EditorPluginName[];
  editorRef: (editorRef: RicosEditorAPI | null) => void;
  isMobile?: boolean;
  environment?: Environment;
}> = ({
  headerRightButtons,
  headerCenter,
  footer,
  content,
  editorRemountKey,
  onChange,
  plugins,
  editorRef,
  isMobile,
  environment,
}) => {
  const pluginsKey = plugins.join(',');
  const [isBusy, setIsBusy] = React.useState(false);
  return (
    <Card
      backgroundColor="#ECEFF3"
      footer={footer}
      width="100%"
      header={{
        start: (
          <>
            Editor{' '}
            {isBusy && (
              <Tooltip
                inline
                content="Editor is in a busy state and cannot be submitted during this time."
              >
                <div className="pt-1">
                  <Loader size="tiny" />
                </div>
              </Tooltip>
            )}
          </>
        ),
        center: headerCenter,
        end: headerRightButtons,
      }}
    >
      <React.Suspense fallback={null}>
        <ErrorBoundary>
          <Editor
            key={editorRemountKey + pluginsKey}
            content={content as any}
            updateContent={content => onChange(content)}
            plugins={plugins}
            editorRef={editorRef}
            onBusyChange={setIsBusy}
            isMobile={isMobile}
            environment={environment}
          />
        </ErrorBoundary>
      </React.Suspense>
    </Card>
  );
};
